<template>
  <div class="form-card fee order-fee-container" style="display: flex;justify-content: space-between">
    <div class="form-content" style="width: 100%">
      <el-form-item label="合作原价(¥)" label-width="115px" prop="cooperative_ori_price">
        <input-or-text :value.sync="formData.cooperative_ori_price" num placeholder="合同价"
                       prefix-icon="icon-renminbi"/>
      </el-form-item>
      <el-form-item v-if="isDouYinXT" label="下单金额(¥)" label-width="115px" :prop="'place_order_money'">
        <input-or-text :value.sync="formData.place_order_money" num placeholder="下单金额"/>
      </el-form-item>
      <el-form-item label="含税收入(¥)" label-width="115px" :prop="'payment_account'">
        <input-or-text :value.sync="formData.payment_account" :disabled="isDouYinXT" num placeholder="含税收入"/>
      </el-form-item>
      <el-form-item label-width="115px">
        <template slot="label">
          <el-tooltip
              :content="(formData.rebates_handle === 'rebates_rate' ? '点击切换为返点金额':'点击切换为返点比例') + '； 客户返点 = 合作原价 * 返点比例'"
              placement="top">
            <div @click="switchRebatesHandle">
              <el-link :underline="false" type="primary">
                <i class="iconfont icon-qiehuan1"/>
                {{ formData.rebates_handle === 'rebates_rate' ? '返点比例(%)' : '返点金额(¥)' }}
              </el-link>
            </div>
          </el-tooltip>
        </template>
        <template>
          <div v-if="formData.rebates_handle === 'rebates_rate'">
            <input-or-text :value.sync="formData.rebates_rate" prefix-icon="" suffix-icon="icon-80" num
                           placeholder="请输入返点比例"/>
          </div>
          <div v-else>
            <input-or-text :value.sync="formData.rebates_amount" num placeholder="请输入返点金额"/>
          </div>
        </template>
      </el-form-item>
      <el-form-item label="代下单平台费(¥)" label-width="115px">
        <input-or-text :value.sync="formData.platform_fee_po" num placeholder="代下单平台费"/>
      </el-form-item>
      <el-form-item label="粉丝福利(¥)" label-width="115px">
        <input-or-text :value.sync="formData.weal_price" num placeholder="粉丝福利"/>
      </el-form-item>
      <el-form-item label="授权价(¥)" label-width="115px" v-permission="'view_adv_order_price_div'">
        <input-or-text :value.sync="formData.authorized_price" num placeholder="授权价"/>
      </el-form-item>
      <el-form-item label="投流费(¥)" label-width="115px">
        <input-or-text :value.sync="formData.invest_flow_fee" num placeholder="投流费"/>
      </el-form-item>
      <el-form-item label="其他费(¥)" label-width="115px">
        <input-or-text :value.sync="formData.other_fee" num placeholder="其他费"/>
      </el-form-item>
      <el-form-item label="支付方式" label-width="115px">
        <el-select class="el-input-c"
                   v-model="formData.pay_method"
                   v-if="editField==='pay_method'||!formData.pay_method"
                   @change="clearEditField"
                   @focus="editField='pay_method'"
                   clearable
                   placeholder="请选择支付方式">
          <el-option-group :label="`支持如下${optionsPayMethods.length}种支付方式`">
            <el-option v-for="item in optionsPayMethods" :key="item.value"
                       :value="item.value" :label="item.label"></el-option>
          </el-option-group>
        </el-select>
        <div class="input-val" @click="editField='pay_method'" v-else>
          <span class="pay_method">{{ formData.pay_method || '--' }}</span>
        </div>
      </el-form-item>
      <template v-if="!isPureLive" class="item">
        <el-form-item label="是否挂车" label-width="115px">
          <el-radio-group v-model="formData.is_trailer">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="挂车佣金(%)" label-width="115px">
          <input-or-text :value.sync="formData.commission_trailer" prefix-icon="" suffix-icon="icon-80" num
                         placeholder="挂车佣金"/>
        </el-form-item>
        <el-form-item label="购物车费用(¥)" label-width="115px">
          <input-or-text :value.sync="formData.cart_charges" num placeholder="购物车费用"/>
        </el-form-item>
      </template>
      <el-form-item label="线下结佣(¥)" label-width="115px">
        <input-or-text :value.sync="formData.offline_rebate" num placeholder="线下结佣"/>
      </el-form-item>
      <el-form-item label="是否直播" label-width="115px">
        <el-radio-group v-model="formData.is_lb">
          <el-radio-button :label="1">是</el-radio-button>
          <el-radio-button :label="0">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="直播佣金(%)" label-width="115px">
        <input-or-text :value.sync="formData.commission_rate" prefix-icon="" suffix-icon="icon-80" num
                       placeholder="直播佣金"/>
      </el-form-item>
      <el-form-item label="直播坑位费(¥)" label-width="115px">
        <input-or-text :value.sync="formData.cart_commission" num placeholder="直播坑位费"/>
      </el-form-item>
      <el-form-item v-permission="'view_money_achievement'" v-if="isPureLive !== true" label="整单业绩金额(¥)"
                    label-width="115px">
        <input-or-text :value.sync="formData.money_achievement" num placeholder="整单业绩金额"/>
      </el-form-item>
      <el-form-item v-if="formData.pid" label="是否保量" label-width="115px">
        <el-radio-group v-model="formData.is_quantity">
          <el-radio-button :label="`Y`">是</el-radio-button>
          <el-radio-button :label="`N`">否</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <div style="display: flex;">
        <el-form-item label="备注" label-width="115px" class="remark-form-item">
          <el-input class="el-input-c" v-model="formData.remark" type="textarea"
                    :rows="10" size="mini"
                    placeholder="请输入内容" maxlength="1000" show-word-limit></el-input>
        </el-form-item>
        <div class="fee-tip">
          <!--    含税收入公式      -->
          <div class="fee-tip__item">
            <div class="fee-tip__item-field">
              <div>{{ formData.payment_account|numberFormat(2) }}</div>
              <div>含税收入</div>
            </div>
            <div class="fee-tip__item-symbol">=</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.place_order_money|numberFormat(2) }}</div>
              <div>下单金额（抖音星图时存在）</div>
            </div>
            <div class="fee-tip__item-symbol">* 97%</div>
          </div>
          <!--    返点金额公式      -->
          <div class="fee-tip__item">
            <div class="fee-tip__item-field">
              <div>{{ formData.rebates_amount|numberFormat(2) }}</div>
              <div>返点金额</div>
            </div>
            <div class="fee-tip__item-symbol">=</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.cooperative_ori_price|numberFormat(2) }}</div>
              <div>合作原价</div>
            </div>
            <div class="fee-tip__item-symbol">*</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.rebates_rate|numberFormat(2) }}%</div>
              <div>返点比例</div>
            </div>
          </div>
          <!--    广告收入公式      -->
          <div class="fee-tip__item one-row">
            <div class="fee-tip__item-field">
              <div>{{ formData.adv_revenue|numberFormat(2) }}</div>
              <div>广告收入</div>
            </div>
            <div class="fee-tip__item-symbol">=（</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.payment_account|numberFormat(2) }}</div>
              <div>含税收入</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.platform_fee_po|numberFormat(2) }}</div>
              <div>代下单平台费</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.weal_price|numberFormat(2) }}</div>
              <div>粉丝福利</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.invest_flow_fee|numberFormat(2) }}</div>
              <div>投流费</div>
            </div>
            <div class="fee-tip__item-symbol">）➗（1 + 税点）</div>
          </div>
          <!--    广告执行价公式      -->
          <div class="fee-tip__item">
            <div class="fee-tip__item-field">
              <div>{{ formData.exec_price|numberFormat(2) }}</div>
              <div>广告执行价</div>
            </div>
            <div class="fee-tip__item-symbol">=</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.adv_revenue|numberFormat(2) }}</div>
              <div>广告收入</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.cart_commission|numberFormat(2) }} ➗（1 + 税点）</div>
              <div>直播坑位费</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.offline_rebate|numberFormat(2) }} ➗（1 + 税点）</div>
              <div>线下结佣</div>
            </div>
          </div>
          <!--    实际所得      -->
          <div class="fee-tip__item">
            <div class="fee-tip__item-field">
              <div>{{ formData.real_income|numberFormat(2) }}</div>
              <div>实际所得</div>
            </div>
            <div class="fee-tip__item-symbol">=</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.adv_revenue|numberFormat(2) }}</div>
              <div>广告收入</div>
            </div>
            <div class="fee-tip__item-symbol">-</div>
            <div class="fee-tip__item-field">
              <div>{{ formData.rebates_amount|numberFormat(2) }} ➗（1 + 税点）</div>
              <div>返点金额</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputOrText from "@/components/InputOrText/index.vue";
import {calculateFee} from "@/views/adOrder";
import {getArtistRebateRate} from "@/api/order";

export default {
  name: "OrderPartFeeFill",
  components: {InputOrText},
  props: {
    optionsPayMethods: Array,
    formData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editField: '',//当前编辑的字段
    }
  },
  computed: {
    isDouYinXT() {
      // 是否包含抖音星图
      return Array.isArray(this.formData.platforms) && this.formData.platforms.includes('抖音星图')
    },
    isPureLive() {
      // 是“纯直播”
      const {isPureLive} = this.$route.query
      return isPureLive && isPureLive === 'true'
    },
    isRegularOrder() {
      let kind = this.$route.query.kind || ''
      if (!kind) {
        if (this.formData.pid || this.$route.query.source_id || this.formData.puke_id || this.isPureLive) {
          kind = ''
        } else {
          kind = 'RegularOrder'
        }
      }
      return kind === 'RegularOrder'
    }
  },
  watch: {
    formData: {
      deep: true,
      // immediate: true,
      async handler(value) {
        const result = calculateFee(value, this.isDouYinXT)
        for (let key in result) {
          this.formData[key] = result[key] || null
        }
      }
    },
    'formData.artist_id': {
      handler() {
        this.setArtistRebateRate()
      }
    },
    'formData.platforms': {
      handler() {
        this.setArtistRebateRate()
      }
    },
  },
  mounted() {
    this.setArtistRebateRate()
  },
  methods: {
    setArtistRebateRate: async function () {
      const {artist_id, platforms, order_no} = this.formData
      if (!(artist_id && Array.isArray(platforms) && platforms.length > 0)) {
        this.formData.rate = 0
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '加载红人分成比例...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const {model} = await getArtistRebateRate({artist_id, platforms, order_no})
      this.formData.rate = model
      setTimeout(() => {
        loading.close()
      }, 150)
    },
    clearEditField() {
      //清空当前编辑字段
      this.editField = null
    },
    switchRebatesHandle: function () {
      if (this.formData.rebates_handle === 'rebates_rate') {
        this.formData.rebates_handle = 'rebates_amount'
      } else {
        this.formData.rebates_handle = 'rebates_rate'
      }
    }
  }
}
</script>
<style lang="scss">
.order-fee-container {
  .el-form-item {
    width: calc((100% - 4px) / 4) !important;

    .el-form-item__content {
      width: calc(100% - 120px);
      margin-left: 0 !important;
    }
  }

  .el-form-item.remark-form-item {
    width: calc((100% - 40px) / 4 * 1) !important;
    margin-bottom: 0 !important;
    margin-right: 18px !important;

    .el-form-item__content {
      height: 100% !important;
    }
  }

  .el-radio-group {
    width: 100%;

    .el-radio-button {
      width: 50%;

      span {
        width: 100%;
      }
    }
  }

  .el-select {
    width: 100%
  }

  .input-val {
    width: calc(100% - 12px) !important;
    min-width: unset !important;
    max-width: unset !important;
    overflow-x: hidden;
    text-align: center;
    border: 1px solid rgb(220, 223, 230);
    padding-left: 5px;
    padding-right: 5px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 1em;
    line-height: 26px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-family: FjallaOne-Regular, sans-serif !important;

    i {
      color: rgb(192, 196, 204);
      line-height: 1;
      width: 16px;
    }
  }

  .el-button--mini.el-popover__reference {
    padding: 0 !important;
  }

  .el-textarea__inner {
    border-radius: 18px !important;
    height: 100% !important;
  }

  .el-textarea {
    height: 100% !important;
  }

  .fee-tip {
    width: calc((100% - 40px) / 4 * 3);
  }
}
</style>
